import { observer } from 'mobx-react-lite';
import GeneralInfor from './components/GeneralInfor';
import PetInfor from './components/PetInfor';
import ServiceList from './components/ServiceList';
import { useStore } from '@/hooks/useStore';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { convertServicePrice, formatNumber } from '@/utils/utils';
import { Button } from '@/components/common/Button';
import { ROUTES } from '@/configs/constants';

export default observer(function AppointmentDetail() {
    // hooks
    const { t } = useTranslation();
    const { code } = useParams();
    const navigate = useNavigate();
    // store
    const { appointmentStore: { appointment, getAppointmentDetail } } = useStore();

    // lifecycle
    useEffect(() => {
        code && getAppointmentDetail({ code });
    }, [code]);

    return (
        <div className='flex flex-col gap-4 pb-6'>
            <div className='grid grid-cols-2 gap-3 max-h-full'>
                <div><GeneralInfor /></div>
                <div><PetInfor /></div>
            </div>
            <div>
                <ServiceList />
            </div>
            <div>
                <div className='bg-white p-4 flex flex-col items-end'>
                    <div className='flex justify-between w-full lg:w-[600px] mb-2'>
                        <p className=''>{t('words_title.total_service_amount')}</p>
                        <p className=' text-[15px]'>{`${formatNumber(appointment?.totalAmountBeforeDiscount ?? 0)} VND`}</p>
                    </div>
                    <div className='flex justify-between w-full lg:w-[600px] mb-2'>
                        <p className=''>
                            {t('words_title.total_discount')}
                            {' '}
                            <span className='text-[#0075FF]'>{appointment?.promotionCode ? `(${appointment?.promotionCode})` : ''}</span>
                        </p>
                        <p className='text-[15px]'>{`${formatNumber(appointment?.totalDiscount ?? 0)} VND`}</p>
                    </div>
                    <div className='flex justify-between w-full lg:w-[600px]'>
                        <p className='font-semibold'>{t('words_title.expected_total_amount')}</p>
                        <p className='font-semibold text-[1.3125rem]'>{`${formatNumber(appointment?.totalAmount ?? 0)} VND`}</p>
                    </div>
                </div>
            </div>
            <div className='w-full text-right'>
                <Button onClick={() => navigate(ROUTES.appointmentManagement.href)} className='w-56' variant='clear'>{t('button.back_page')}</Button>
            </div>
        </div>
    );
});
